export default __webpack_public_path__ + "static/media/21.8a7e0746.png";